"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ToyotaType_Light_ttf_1 = require("../../assets/ToyotaFonts/ToyotaType-Light.ttf");
const light = {
    fontFamily: 'light',
    src: `
    url(${ToyotaType_Light_ttf_1.default}) format('truetype')
  `,
    // tslint:disable-next-line:max-line-length
    unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
exports.default = light;
//# sourceMappingURL=light.js.map